import axios from "axios";

const token = localStorage.getItem("token") || null;

const api = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_BACKEND_API,
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export default api;
